module.exports = __webpack_public_path__ + "static/tags-based-configuration_1-296fcd82998ff173b097aff345ea5564.png";